let activeLocalStream = null;

const stopStreamTracks = (stream) => {
  stream?.getTracks?.().forEach((track) => {
    track.stop();
  });
};

export const releaseMicrophoneStream = () => {
  if (activeLocalStream) {
    stopStreamTracks(activeLocalStream);
    activeLocalStream = null;
  }
};

/**
 * Shared getUserMedia factory for prime + sip.js SDH.
 * Mic must be acquired BEFORE RTCPeerConnection so Chrome exposes real LAN
 * host ICE candidates instead of .local mDNS names (UCM cannot route to those).
 */
export const createMicrophoneStreamFactory = () => (constraints, _handler, _options) => {
  const wantsAudio = Boolean(constraints?.audio);
  const wantsVideo = Boolean(constraints?.video);

  if (!wantsAudio && !wantsVideo) {
    return Promise.resolve(new MediaStream());
  }

  if (!navigator?.mediaDevices?.getUserMedia) {
    return Promise.reject(new Error("Microphone access is not available in this browser."));
  }

  if (activeLocalStream?.active) {
    const hasLiveAudio = activeLocalStream.getAudioTracks().some((track) => track.readyState === "live");
    if (hasLiveAudio) {
      return Promise.resolve(activeLocalStream);
    }
    releaseMicrophoneStream();
  }

  return navigator.mediaDevices.getUserMedia(constraints).then((stream) => {
    activeLocalStream = stream;
    return stream;
  });
};

/** Single factory instance used by both microphoneAccess and SipClient. */
export const sharedMicrophoneStreamFactory = createMicrophoneStreamFactory();
